import { Injectable } from '@angular/core';
import { DeadlineDateCalcualator } from '@zaoblako/shared/common/classes/deadline.date.calcualator';
import { TemplateEntityVariableEngine } from '@zaoblako/shared/common/classes/template.entity.variable.engine';
import type { PaginationRequiredQueryInterface } from '@zaoblako/shared/common/dtos/pagination-required-query.dto';
import { TaskFormInterface } from '@zaoblako/shared/modules/task/dtos/task-form.dto';
import { TaskTemplateFindInterface } from '@zaoblako/shared/modules/task/dtos/template/task-template-find.dto';
import type { TaskTemplateHistoryPageInterface } from '@zaoblako/shared/modules/task/dtos/template/task.template.history.page.dto';
import type { TaskTemplateFindQueryInterface } from '@zaoblako/shared/modules/task/dtos/template/task-template-find-query.dto';
import type { TaskTemplatePageInterface } from '@zaoblako/shared/modules/task/dtos/template/task-template-page.dto';
import { map, Observable } from 'rxjs';
import { BaseService } from '../base.service';

@Injectable({ providedIn: 'root' })
export class TaskTemplateService extends BaseService {
  protected baseUrl = '/task/template';

  public findMany(queryParams: TaskTemplateFindQueryInterface): Observable<TaskTemplatePageInterface> {
    return this.http.get<TaskTemplatePageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getTaskFormByTemplate(id: number): Observable<{ task: TaskFormInterface }> {
    return this.findById<TaskTemplateFindInterface>(id).pipe(
      map((template) => {
        const task = <TaskFormInterface>{};
        const fieldsToCopy: Array<keyof TaskTemplateFindInterface> = [
          'status',
          'creditPayment',
          'contragent',
          'responsible',
          'organization',
          'filial',
          'unit',
          'direction',
          'type',
          'priority',
          'amount',
          'nds',
          'userAuditors',
          'userGroupAuditors'
        ];

        fieldsToCopy.forEach((field) => (task[field] = template[field]));
        task.date = DeadlineDateCalcualator.getInstance().calculateDate(
          template.deadline,
          template.planning.nearestDate || template.planning.runDate
        );
        task.orders = [
          {
            amount: template.amount,
            subject: TemplateEntityVariableEngine.getInstance().parse(template.subject),
            date: task.date
          }
        ];
        task.scheme = template.scheme;
        task.subject = TemplateEntityVariableEngine.getInstance().parse(template.subject);

        if (template.currency) {
          task.currency = template.currency;
          task['rate'] = template.currency?.latestRate?.rate || 1;
        }

        return { task };
      })
    );
  }

  public historyById(
    templateId: number,
    queryParams: PaginationRequiredQueryInterface
  ): Observable<TaskTemplateHistoryPageInterface> {
    return this.http.get<TaskTemplateHistoryPageInterface>(`${this.baseUrl}/${templateId}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
